import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/ShootApi/'; // 影像
// 获取影像时间
export const isHaveImageBySensor = (data)=>{
  return getInterface.post(`${prefixUrl}isHaveImageBySensor`, data);
}
// 获取时间对应影像
export const getImageByUIColorName = (data)=>{
  return getInterface.post(`${prefixUrl}getImageByUIColorName`, data);
}